export function findSameItem(item, modifiers, cartItems) {
  if (item.reedemptionRule) return null;
  const records = cartItems.filter(
    element =>
      !element.reedemptionRule &&
      element.id == item.id &&
      compareTwoItemModifiers(modifiers, element.modifiers)
  );
  if (records.length > 0) return records[0];
  else return null;
}

function compareTwoItemModifiers(modifiers1, modifiers2) {
  var allSame = true;
  if (!modifiers1 || modifiers1.length == 0)
    if (!modifiers2 || modifiers2.length == 0) return true;
    else return false;
  else if (!modifiers2 || modifiers2.length == 0) return false;

  for (var element of modifiers1) {
    if (
      modifiers2.filter(
        p =>
          p.ID == element.ID &&
          p.quantity == element.quantity &&
          compareTwoItemModifiers(
            element.selectedSubmodifiers,
            p.selectedSubmodifiers
          )
      ).length == 0
    ) {
      allSame = false;
      break;
    }
  }
  return allSame;
}

export function findSameGiftItem(item, message, cartItems) {
  let find = null;
  const records = cartItems.filter(element => element.id == item.id);

  for (let j = 0; j < records.length; j++) {
    const record = records[j];
    if (messageEqual(record.message, message)) {
      find = record;
      break;
    }
  }
  return find;
}
export function itemQuantity(item, modifiers, cartItems) {
  const find = findSameItem(item, modifiers, cartItems);
  if (find) {
    return find.quantity;
  }
  return 0;
}
export function giftItemQuantity(item, message, giftCartItems) {
  const find = findSameGiftItem(item, message, giftCartItems);
  if (find) {
    return find.quantity;
  }
  return 0;
}
export function messageEqual(msg1, msg2) {
  if (
    msg1.Email != msg2.Email ||
    msg1.From != msg2.From ||
    msg1.To != msg2.To ||
    msg1.Message != msg2.Message
  )
    return false;
  return true;
}
